import React, { useState, useEffect } from 'react';

// OUR COMPONENTS
import Search from './DeviceSearch';
import Single from './DeviceSingle';
import All from './DeviceAll';

import CustomerSingle from '../../customers/CustomerEdit';
import UserReport from '../../../reports/userreports/ReportDetail';
import PhoneNumberSingle from './DeviceNumberSingle';
import useDeviceRequest from '../../../../requests/DeviceRequest';
import Loader from '../../../common/Loader';

const Device = ({
  location,
  navigate,
  handleViewTwilioNumbers,
  errorHandler,
}) => {
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [viewAllDevices, setViewAllDevices] = useState(false);
  const [backTo, setBackTo] = useState(null);
  const [addNewDevice, setAddNewDevice] = useState(false);
  const { getDevice } = useDeviceRequest();

  useEffect(() => {
    // Handles redirects from the customer edit page
    if (location?.state?.devicesRedirect) {
      const { devicesRedirect } = location.state;

      // Gets single device
      const fetchDevice = async () => {
        const device = await getDevice(devicesRedirect, errorHandler);

        console.log('Redirected to device:', device);

        // If the device not found, device page acts as normal
        if (!device) return;

        setSelectedDevice(device);
        setViewAllDevices(false);
        setBackTo('Customer');
      };

      fetchDevice();
    }
  }, [location, errorHandler]);

  const handleViewAllDevices = () => {
    setViewAllDevices(true);
  };

  const handleBackToAllDevices = () => {
    setSelectedDevice(null);
    setSelectedCustomer(null);
    setSelectedUser(null);
    setSelectedNumber(null);
    setViewAllDevices(true);
    setBackTo('All');
    setAddNewDevice(false);
  };

  const handleBackClick = () => {
    setSelectedDevice(null);
    setSelectedCustomer(null);
    setSelectedUser(null);
    setSelectedNumber(null);
    setViewAllDevices(false);
    setAddNewDevice(false);
    setBackTo('All');
  };

  const handleAddNewDevice = () => {
    setViewAllDevices(false);
    setAddNewDevice(true);
    setBackTo('All');
  };

  const onClickDeviceName = (device, backToAll) => {
    setSelectedDevice(device);
    setViewAllDevices(false);
    setBackTo(backToAll ? 'All' : null);
  };

  const onClickCustomerName = (customer) => {
    navigate('/admin/customers/' + customer.customer_id);
  };

  const onClickUserName = (customerUser) => {
    setSelectedUser(customerUser);
  };

  const onClickPhoneNumber = (phoneNumber) => {
    setSelectedNumber(phoneNumber);
  };

  /*
    Generate main content
  */
  const generateContent = () => {
    if (location?.state?.devicesRedirect && !selectedDevice) {
      return <Loader />;
    }

    if (viewAllDevices) {
      return (
        <All
          errorHandler={errorHandler}
          backButtonClick={handleBackClick}
          showSingleDevice={onClickDeviceName}
          addNewDevice={handleAddNewDevice}
        />
      );
    }

    // Have a Selected Device
    if (selectedDevice || addNewDevice) {
      let backButtonClick = handleBackClick;
      if (backTo === 'All') backButtonClick = handleBackToAllDevices;
      else if (backTo === 'Customer') backButtonClick = () => navigate(-1);

      return (
        <Single
          device={selectedDevice}
          isNew={addNewDevice}
          backButtonClick={backButtonClick}
          errorHandler={errorHandler}
        />
      );
    }

    // // Have a Selected Customer
    if (selectedCustomer) {
      return (
        <CustomerSingle
          customer={selectedCustomer}
          backButtonClick={handleBackClick}
          errorHandler={errorHandler}
        />
      );
    }

    if (selectedUser) {
      return <UserReport userData={selectedUser} />;
    }

    if (selectedNumber) {
      return (
        <PhoneNumberSingle
          device={selectedNumber}
          backButtonClick={handleBackClick}
        />
      );
    }

    return (
      <Search
        handleViewTwilioNumbers={handleViewTwilioNumbers}
        viewAllDevices={handleViewAllDevices}
        showSingleDevice={onClickDeviceName}
        showSingleCustomer={onClickCustomerName}
        showSingleUserReport={onClickUserName}
        showSinglePhoneNumber={onClickPhoneNumber}
      />
    );
  };

  return <>{generateContent()}</>;
};

export default Device;
